//    _____ _____    _____            _
//   / ____|  __ \  |  __ \          (_)
//  | (___ | |__) | | |  | | ___  ___ _  __ _ _ __
//   \___ \|  ___/  | |  | |/ _ \/ __| |/ _` | '_ \
//   ____) | |      | |__| |  __/\__ \ | (_| | | | |
//  |_____/|_|      |_____/ \___||___/_|\__, |_| |_|
//                                       __/ |
//                                      |___/

import { generateColorSteps } from "../base/theme/design.base";
import { DesignConfigDark as defaultTHeme } from "..//base/theme/theme.light";
import { PRIMARY_COLOR } from "./design.const";

// Custom JS Doc are here!
/**
 * @typedef {{
 *     ayex: string,
 * }} OverridenConfig
 */
const override = Object.assign({}, defaultTHeme, {});
/**
 * @type {DesignConfigAll}
 */
const DesignConfig = {
	light: override,
	dark: Object.assign({}, override, {
		baseBgColor: "#000000",
		text2Color: "#ffffff",
		textColor: "#FCFCFC",
		secondaryColor: "#7f7f7f",
		borderColor: "#1c2438",
		browserThemeColor: "#000000",
		getStartedButtonBackgroundColor: "#FCFCFC29",
	}),
};

export default DesignConfig;
